import cytoscape from 'cytoscape'

/** Shared COSE layout constants for initial graph render (ConnectionsGraph + FolderConnectionsGraph).
 * High repulsion + low gravity + high nodeOverlap required for dense hub-and-spoke graphs (21+ nodes).
 * nodeOverlap is the dominant label-overlap control: it pads each node's collision radius so centres
 * are forced apart far enough that their CSS text labels cannot reach each other. */
export const COSE_BASE_LAYOUT: Partial<cytoscape.LayoutOptions> = {
  name: 'cose',
  animate: false,
  fit: true,
  padding: 120,
  nodeOverlap: 300,
  idealEdgeLength: () => 380,
  nodeRepulsion: () => 450000,
  gravity: 0.08,
  componentSpacing: 220,
  numIter: 5000,
  coolingFactor: 0.97,
} as Partial<cytoscape.LayoutOptions>

/** Aggressive spread-on-demand constants for FolderConnectionsGraph "Spread" button. */
export const COSE_SPREAD_LAYOUT: Partial<cytoscape.LayoutOptions> = {
  name: 'cose',
  animate: true,
  animationDuration: 800,
  fit: true,
  padding: 120,
  nodeOverlap: 160,
  idealEdgeLength: () => 400,
  nodeRepulsion: () => 650000,
  gravity: 0.06,
  componentSpacing: 250,
  numIter: 4000,
  coolingFactor: 0.97,
} as Partial<cytoscape.LayoutOptions>
